<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2 id="label_SiteBlockTitle">{{translate?.general.buttons.new.singular}} {{layerLabel}}</h2>
            <span class="sub" id="label_SiteBlockSubtitleBlock" *ngIf="data.layer == 'block'">{{translate?.site.messages.defineTheBuilding}}</span>
            <span class="sub" id="label_SiteBlockSubtitleLevel" *ngIf="data.layer == 'level'">{{translate?.site.messages.defineTheLevels}}</span>
            <span class="sub" id="label_SiteBlockSubtitleArea" *ngIf="data.layer == 'area'">{{translate?.site.messages.defineTheAreas}}</span>

        </div>
        <button class="icon-btn" aria-label="Close" id="btn_SiteBlockClose" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body mp-body">
        <form [formGroup]="siteBlockForm">
            <label class="field-label mandatory" id="label_SiteBlockNameLabel">{{layerLabel}} {{translate?.site.fields.name.singular}}</label>

            <div class="field-row field-row--single">
                <div>
                    <input pInputText [placeholder]="translate?.site.messages.enterAPlaceholder + ' ' + layerLabelLower + ' ' + translate?.site.fields.name.singular" formControlName="blockName" id="input_SiteBlockNameField"
                        (keydown.enter)="onLayerCreate()"
                        [ngClass]="{'invalid-input': siteBlockForm.get('blockName')?.invalid && (siteBlockForm.get('blockName')?.dirty || siteBlockForm.get('blockName')?.touched)}"
                    />
                    <div class="p-error text-10 mt-1" id="label_SiteBlockNameError"
                        *ngIf="
                            (siteBlockForm.controls['blockName'].touched || siteBlockForm.controls['blockName'].dirty) &&
                            siteBlockForm.controls['blockName'].invalid
                        ">
                        <span id="label_SiteBlockNameRequiredError" *ngIf="siteBlockForm.controls['blockName'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        <span id="label_SiteBlockNamePatternError" *ngIf="siteBlockForm.controls['blockName'].errors?.pattern">Only letters and numbers are allowed</span>
                        <span id="label_SiteBlockNameMaxLengthError" *ngIf="siteBlockForm.controls['blockName'].errors?.maxlength">{{translate?.setup.modules.types.validationFE.maximum80Chars}}</span>

                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="flx-modal__footer">
        <button class="custella-btn-white" id="btn_SiteBlockCancel" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button type="button" [loading]="layerCreationInProgress" [label]="translate?.general.buttons.save.singular" id="btn_SiteBlockSave" styleClass="h-32" (onClick)="onLayerCreate()" ></p-button>
    </div>
</div>